import $ from 'jquery';

class RecipeListing {
    init() {
        this.fixInlineDropdownStyles();
    }

    fixInlineDropdownStyles() {
        // Target the dropdown and its children, then remove min-height
        $('.dropdown-toggle').click(() => {
            $('.dropdown-menu.show, .dropdown-menu.show *').css('min-height', '');
        });
    }
}

export default RecipeListing;

$(() => {
    const recipeListing = new RecipeListing();
    recipeListing.init();
});